import React, { useState } from "react";
import Select from "react-select";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { debounce, truncate } from "lodash";
import queryString from "query-string";
import { fetchActionsUtil } from "../../utils/helpers";
import AsyncSelect from "react-select/async";

const CompanyPicker = ({
  jobNumber,
  value,
  setUpCompanyDetails,
  placeholder = "Select Job PO...",
  ...props
}) => {
  const { backendUrl } = useAuth();
  const [companyId, setCompanyId] = useState("");
  const [companyDetails, setCompany] = useState({});

  const fetchCompanyPricing = async (query) => {
    const data = await fetchActionsUtil(
      `${backendUrl}/api/company/get-other-company-pricing?companyID=${query}`
    );

    return data;
  };

  const { data, isFetching, isSuccess } = useQuery(
    ["GET_EB_COMPANY", companyId],
    () => Boolean(companyId) && fetchCompanyPricing(companyId),
    {
      enabled: Boolean(companyId),
      keepPreviousData: true,
      onSuccess: ({ data }) => {
        if (data) {
          setUpCompanyDetails({
            ...companyDetails,
            ...data,
          });
        }
      },
    }
  );

  const fetchCompanies = async (inputValue, callback) => {
    try {
      const data = await fetchActionsUtil(
        `${backendUrl}/api/company/get-company-branches?name=${inputValue}`,
        "GET"
      );

      if (data?.branches) {
        callback(
          (data.options = data?.branches?.map((el) => ({
            ...el,
            label: el.name,
            value: el.name,
          })))
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const debouncedFetchUsers = debounce(fetchCompanies, 500);
  const loadOptions = (inputValue, callback) => {
    debouncedFetchUsers(inputValue, callback);
  };

  return (
    <AsyncSelect
      classNamePrefix={"form-select"}
      className=" border"
      placeholder="Select Company"
      name={"branches"}
      isSearchable={true}
      defaultOptions
      menuPosition="fixed"
      isClearable
      loadOptions={(inputValue, callback) => loadOptions(inputValue, callback)}
      onChange={(e) => {
        setCompanyId(e?.BackendUrl);
        setCompany(e);
        setUpCompanyDetails(e);
      }}
    />
  );
};

export default CompanyPicker;
